import React from 'react';
import ReactDOM from 'react-dom';
import App from './Routes';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
